import { render, staticRenderFns } from "./GBrandStoryForm.vue?vue&type=template&id=4891afea&scoped=true&"
import script from "./GBrandStoryForm.vue?vue&type=script&lang=ts&"
export * from "./GBrandStoryForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandStoryForm.vue?vue&type=style&index=0&id=4891afea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4891afea",
  null
  
)

export default component.exports